export default __webpack_public_path__ + "static/media/computer.d4552c2f.png";